import intersects from 'rectangles-intersect';

import { TFullRectangle, IRectangle } from './rectangles.types';

const transformRect = ({ x, y, offsetX, offsetY }: IRectangle): TFullRectangle => [
  [x, y],
  [x + offsetX, y],
  [x + offsetX, y + offsetY],
  [x, y + offsetY],
];

export const ifRectanglesIntersect = (rectangle1: IRectangle, rectangle2: IRectangle): boolean =>
  intersects(transformRect(rectangle1), transformRect(rectangle2));
